import { Radio, RadioGroup } from "@headlessui/react";
import MiniBoxElement from "./miniBoxElement";
import React from "react";

interface Props {
  options: React.ReactNode[];
  selectedItem: number;
  handleChange: (i: number) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Component for buttons to select one value.
 * @param params
 * @returns a row of x amount of buttons.
 */
export const ButtonOptionSelector = ({ options, selectedItem, handleChange, disabled, className }: Props) => (
  <RadioGroup
    value={selectedItem}
    onChange={handleChange}
    className={`flex space-x-1 ${className ? className : ""}`}
    disabled={disabled}
  >
    {options.map((content, i) => (
      <Radio key={i} value={i} className={`rounded-xl ${disabled ? "text-grey bg-grey" : ""}`}>
        <MiniBoxElement selected={selectedItem === i} disabled={disabled}>
          {content}
        </MiniBoxElement>
      </Radio>
    ))}
  </RadioGroup>
);
